/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.8.0-nightly.2026.10.21",
    versionName: "0.8.0-nightly.2026.10.21",
    versionChannel: "nightly",
    buildDate: "2026-10-21T00:14:58.945Z",
    commitHash: "f725a6e7b5a40c2b16cac34191a3b688db7c8826",
};
